import { getSearchVariables } from '../getSearchVariables/getSearchVariables';
import { ArticleSearchCategory } from '#lib/websites/news/constants/categories.js';
import type { ReadonlyURLSearchParams } from '$app/state';
import { capitalizeFirstLetters } from '$global/utils/capitalizeFirstLetters';

export const getNewsHomepageFilter = (
	searchParams: ReadonlyURLSearchParams
) => {
	const variables = getSearchVariables(searchParams);
	const category = variables['category'];
	const geotag = variables['geotag'];
	const artist = variables['artist'];

	// HENI is not a category: it filters on the article's own flag and must never
	// travel with categoryName/artistName/geotagName. Returning early keeps that
	// exclusion structural rather than spreading negative conditions below.
	// `visibility: 'feed'` is kept for parity with every other gallery view.
	if (variables['heni']) {
		return { isHeni: true, visibility: 'feed' };
	}

	const parsedCategory = (() => {
		if (category === 'all') {
			return undefined;
		}

		if (
			(!category || category === ArticleSearchCategory.shoutouts) &&
			!(geotag || artist)
		) {
			return 'shoutOuts';
		}

		return category;
	})();

	return {
		...(parsedCategory && !(geotag || artist) && { visibility: 'feed' }),
		...(geotag && { geotagName: geotag }),
		...(artist && { artistName: artist }),
		...(parsedCategory && {
			categoryName:
				parsedCategory.toLowerCase() === 'nft'
					? 'NFT'
					: capitalizeFirstLetters(parsedCategory),
		}),
	};
};
